<template>
  <div class="failed-to-load">
    <span class="title-large"><slot>Failed to load</slot></span>
  </div>
</template>

<script>
export default {
  name: 'failed-to-load',
};
</script>

<style lang="scss" scoped>
.failed-to-load {
  background: lighten(color('background', 'dark'), 10);
  padding: 1rem;
  text-align: center;
  border-radius: 4px;
  margin: 1rem 0;
}
</style>
